import { render, staticRenderFns } from "./GitSettings.vue?vue&type=template&id=577a9c8e&scoped=true&"
import script from "./GitSettings.vue?vue&type=script&lang=js&"
export * from "./GitSettings.vue?vue&type=script&lang=js&"
import style0 from "./GitSettings.vue?vue&type=style&index=0&id=577a9c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577a9c8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('577a9c8e')) {
      api.createRecord('577a9c8e', component.options)
    } else {
      api.reload('577a9c8e', component.options)
    }
    module.hot.accept("./GitSettings.vue?vue&type=template&id=577a9c8e&scoped=true&", function () {
      api.rerender('577a9c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/GitSettings.vue"
export default component.exports